import { Profile } from './profile';
import { AppDate } from '../envTypes';

export enum ReferralType {
  seller = 'Seller',
  popshop = 'popshop',
}

export interface Referral {
  presenteeUserId: string;
  presenteeUserProfile: Profile;
  referrerUserId: string;
  referrerUserProfile: Profile;
  passcode: string;
  bonus: number;
  referralBonus: number;
  createdAt: AppDate;
  type?: ReferralType;
}

export interface ReferralTransaction {
  userId: string;
  userProfile: Profile; // snapshot, value is not updated when modify profile
  type: 'referral' | 'transfer';
  amount: number;
  balance: number;
  createdAt: AppDate;
  presenteeUserId?: string;
  presenteeUserProfile?: Profile; // snapshot, value is not updated when modify profile
}
